<template>
  <div class="shopping-view">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>我的购物车</el-breadcrumb-item>
    </el-breadcrumb>
    <router-view></router-view>
  </div>
</template>
<script>
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'nav-menu': NavMenu
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="less" scoped>
  .shopping-view{
    padding: 30px 10px 0 10px;
  }
</style>
<style>



// WEBPACK FOOTER //
// src/components/ShoppingCart/shoppingcart.vue


// WEBPACK FOOTER //
// src/components/ShoppingCart/shoppingcart.vue